import {Form, Input} from 'antd';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import StoreActions from 'bukku/redux/Store/actions';

const Styled = styled.div`

    .ant-input {
        padding-left: 1ch;
        font-size: 0.8rem;

        /* white-space: nowrap; */
        /* overflow: hidden; */
        /* text-overflow: ellipsis; */

        font-style: italic;
        line-height: 1rem;
        border: none;
        border-bottom: 1px solid var(--neutral);
        box-shadow: none;

        &:hover, &:active, &:focus, &:focus-within {
            border-bottom: 1px solid #40a9ff;
        }
    }

    /* THIN SCROLLBAR - Works on Firefox - but cannot define custom width */
    textarea {
      scrollbar-width: thin;
      scrollbar-color: rgba(0,0,0,20%);
    }
  
    /* SCROLLBAR - Works on Chrome, Edge, and Safari */
    textarea::-webkit-scrollbar {
      width: 3px;
    }
    
    textarea::-webkit-scrollbar-track {
        background-color: none;
    }
    
    textarea::-webkit-scrollbar-thumb {
      border-radius: 30px; 
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 30%);
  
      &:hover, &:active { 
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 60%);
      }
    }
`;

const {
    setItemInstruction,
} = StoreActions;

class ProductInstructionFormItem extends Component {
    onProductInstructionBlur = e => {
        const {
            // parent
            formRef,
            product,

            // redux
            setItemInstruction,
        } = this.props;
        const instructionText = e.target.value;
        formRef.current.setFieldsValue({
            [`productId_${product.id}.instruction`]: instructionText,
        });
        setItemInstruction(product.productId, instructionText);
    };

    render() {
        const {
            //parent
            product,
        } = this.props;

        return (
            <Styled>
                <Form.Item
                    name={`productId_${product.productId}.instruction`}
                    initialValue={product.instruction}
                    noStyle
                >
                    <Input.TextArea
                        className="input__instruction"
                        onBlur={this.onProductInstructionBlur}
                        placeholder="Instructions"
                        autoSize={{minRows: 1, maxRows: 2}}
                    />
                </Form.Item>
            </Styled>
        );
    }
}

export default connect(() => ({

}), {
    setItemInstruction,
})(ProductInstructionFormItem);
